__turbopack_context__.v({
  "banner": "styles-module__DJQR7G__banner",
  "btnMain": "styles-module__DJQR7G__btnMain",
  "card": "styles-module__DJQR7G__card",
  "cardsTitle": "styles-module__DJQR7G__cardsTitle",
  "cardsWrapper": "styles-module__DJQR7G__cardsWrapper",
  "content": "styles-module__DJQR7G__content",
  "imageFill": "styles-module__DJQR7G__imageFill",
  "imageWrapper": "styles-module__DJQR7G__imageWrapper",
});
